export default "__VITE_ASSET__DEsPJ5wt__"